import React from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	Divider,
	SwipeableDrawer
} from '@material-ui/core';

//import AuthorizedUserContext from "../utils/AuthorizedUserContext";
import ProfileCard from './ProfileCard';
//import AccountInfoBar from './AccountInfoBar';
import NavigationItems from './NavigationItems';
import SupportContact from './SupportContact';
import Branding from './Branding';

const styles = makeStyles(theme => ({
	drawerPaper: {
		width: theme.drawer.width,
		backgroundColor: theme.palette.primary.grey
	},

	logo: {
		display: "flex",
		justifyContent: "center",
		paddingTop: theme.spacing(1),

		[theme.breakpoints.up('lg')]: {
			paddingTop: theme.spacing(2),
			paddingRight: theme.spacing(2),
			paddingBottom: theme.spacing(6)
		}
	},

	darkLogoBg: {
		backgroundColor: theme.palette.primary.darkBlue
	},

	hide: {
		display: "none !important"
	}
}));

function NavigationDrawer(props) {
	//const authenticatedUser = useContext(AuthorizedUserContext);

	let classes = styles();

	let {csm, history, location,
		installable, handleInstallBtn,
		drawerOpen, handleDrawerToggle, signalsNudgeBanner} = props;

	return (
		<SwipeableDrawer
			variant="temporary"
			anchor="right"
			open={drawerOpen}
			onOpen={handleDrawerToggle}
			onClose={handleDrawerToggle}
			/* disableBackdropTransition={!iOS} /* for lower end devices */
			/* disableDiscovery={iOS} /* this disables swipe to go back, maybe can get around it? */
			classes={{
				paper: classes.drawerPaper,
			}}
			ModalProps={{
				keepMounted: true, // Better open performance on mobile.
			}}>
			{/* needs to be div so content overflows and drawer scrolls */}
			<div>
				{signalsNudgeBanner ? signalsNudgeBanner : null}
				<Branding
					light
					secondary
					className={`${classes.logo} ${classes.darkLogoBg}`} />
				<ProfileCard
					history={history}
					closeHandler={handleDrawerToggle} />
				{/*<AccountInfoBar
					isMobile
					location={location}
					user={authenticatedUser}
					showId={authenticatedUser.ghosting}
					className={classes.accountInfo} />*/}
				<NavigationItems
					history={history}
					location={location}
					installable={installable}
					handleInstallBtn={handleInstallBtn}
					closeHandler={handleDrawerToggle} />
				<Divider />
				<SupportContact
					csm={csm}
					history={history}
					closeHandler={handleDrawerToggle} />
			</div>
		</SwipeableDrawer>
	);
}

NavigationDrawer.propTypes = {
	history: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired,
	installable: PropTypes.bool,
	handleInstallBtn: PropTypes.func,
	csm: PropTypes.object,
	drawerOpen: PropTypes.bool,
	handleDrawerToggle: PropTypes.func,
	signalsNudgeBanner: PropTypes.object
};

export default NavigationDrawer;